import React from 'react';
import Menu from '@/components/Dashboard/menu';
import { withRouter, Page } from '@souche-f2e/muji';
import { connect } from '@souche-f2e/muji';
import { dispatch } from '@@/store';
import Detail from '@/components/Dashboard/detail';
import styles from './index.module.less';

@withRouter
class UserInfo extends React.Component {
  constructor() {
    super();
  }

  componentWillMount() {
    dispatch.user.LOAD_USER();
    dispatch.user.userinfo();
  }

  render() {
    let { user, isLogin } = this.props;

    // 检查 login 状态
    if (isLogin === false) {
      this.props.router.push('/signIn');
    }

    user = user || {};

    const items = [
      ['公司 ID', user.partnerId],
      ['公司名称', user.name],
      ['公司描述', user.description],
      ['联系 Email', user.email],
    ];

    return (
      <div className={styles.detail}>
        <Menu />
        <div style={{ flex: 1 }}>
          <Detail items={items} title="账号详情" />
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const user = state.user;
  return {
    hasUserInfoCache: user.hasUserInfoCache,
    user: user.user,
    isLogin: user.isLogin
  }
}

export default connect(mapStateToProps)(UserInfo);